import React from 'react'
import '../Theme.css';
import './Back.css';
import {HiArrowNarrowLeft} from "react-icons/hi";
import {useHistory} from "react-router-dom";

function Back() {
    const history = useHistory();

    const onBackClick = () => {
        history.goBack();
    }

    return (
        <button className="BackButton" onClick={onBackClick}>
            <HiArrowNarrowLeft size={24}/>
        </button>
    )
}

export default Back;
